import { memo, type PropsWithChildren, type ReactElement } from 'react';
import { Avatar, Chip, type ChipProps } from '@mui/material';

export const UnknownChip = memo(
  (props: PropsWithChildren<ChipProps>): ReactElement => (
    <Chip {...props} avatar={<Avatar>!</Avatar>} color="warning" label="Unknown" variant="outlined" />
  ),
);
